import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import AIBuddyPanel from './AIBuddyPanel';

/**
 * Right utility rail — dark-navy column that mirrors the left sidebar.
 * Layout: children scroll in the top area; Spark launcher pinned at the bottom.
 * Hidden below `lg` — Spark falls back to a fixed floating pill on smaller screens.
 */
export const RightUtilityRail = ({ children, sparkMode = 'student' }) => {
  const [sparkOpen, setSparkOpen] = useState(false);

  return (
    <>
      {/* Desktop: right rail column, fixed to the right edge */}
      <aside
        className="hidden lg:flex flex-col"
        aria-label="Utility"
        data-testid="right-utility-rail"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: '20rem',
          background: 'linear-gradient(180deg, #0B1220 0%, #0F172A 100%)',
          borderLeft: '1px solid rgba(255, 255, 255, 0.06)',
          zIndex: 30,
          color: '#E2E8F0',
        }}
      >
        {/* Inner content — scrollable */}
        <div className="flex-1 overflow-y-auto p-3 space-y-3 rail-content" data-testid="right-utility-content">
          {children}
        </div>

        {/* Spark launcher pinned at the bottom */}
        <div className="border-t border-white/5 p-3 bg-black/20">
          <button
            onClick={() => setSparkOpen(true)}
            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-white text-sm font-bold shadow-lg transition-transform hover:scale-[1.02]"
            style={{
              background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
              fontFamily: "'Manrope', sans-serif",
            }}
            data-testid="rail-spark-btn"
            title="Ask Spark"
          >
            <Sparkles className="w-4 h-4" />
            <span className="flex-1 text-left">Spark</span>
            <span className="text-[11px] opacity-80 font-medium">Ask me</span>
          </button>
          <p className="text-[11px] text-slate-400 mt-1.5 px-1 text-center">Your CodeITT Learning Companion</p>
        </div>
      </aside>

      {/* Mobile / tablet: floating pill in bottom-right corner */}
      <button
        onClick={() => setSparkOpen(true)}
        className="lg:hidden fixed bottom-4 right-4 z-40 flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full shadow-lg text-white font-bold text-sm"
        style={{
          background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
          fontFamily: "'Manrope', sans-serif",
        }}
        data-testid="rail-spark-fab"
        title="Ask Spark"
      >
        <Sparkles className="w-4 h-4" />
        <span>Spark</span>
      </button>

      <AIBuddyPanel open={sparkOpen} onClose={() => setSparkOpen(false)} mode={sparkMode} />
    </>
  );
};

export default RightUtilityRail;
